export const setCookie = (name, value, days) => {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const getCookie = name => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';').map(c => c.trim());

  if (!ca) return '';

  const cookie = ca.find(cookie => cookie.includes(nameEQ));
  const cookieValue = cookie && cookie.split('=');

  return cookieValue && cookieValue[1];
};

export const deleteCookie = name => {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
};
